export const getGeneralReport = (state) => {
  if (state.generalReport && state.generalReport.weekly_data.length > 1) {
    const labels = state.generalReport.weekly_data.map((item) => item.label); // Lista de labels
    const attributes = Object.keys(state.generalReport.weekly_data[0]).filter(
      (key) => key !== "label"
    ); // Excluir 'label'

    // Crear la lista de datos con el formato deseado
    const dataList = attributes.map((attr) => {
      const row = [attr]; // Agregar el nombre del atributo como primer elemento
      row.push(...state.generalReport.weekly_data.map((item) => item[attr])); // Agregar los valores correspondientes
      return row;
    });

    return { labels, data: dataList };
  } else {
    return { labels: [], data: [] };
  }
};
export const getVentasAsesor = (state) => {
  if (state.generalReport && state.generalReport.users_counters.length > 1) {
    // Crear la lista de datos con el formato deseado
    const labels = Object.keys(state.generalReport.users_counters[0]);
    const dataList = state.generalReport.users_counters.map((user) => [
      user["usuario"],
      ...labels.slice(1).map((label) => user[label]),
    ]);

    return { labels, data: dataList };
  } else {
    return { labels: [], data: [] };
  }
};
export const getVentasInteracciones = (state) => {
  if (
    state.generalReport &&
    state.generalReport.weekly_sales_interactions_data.length > 1
  ) {
    const labels = state.generalReport.weekly_sales_interactions_data.map(
      (item) => item.label
    ); // Lista de labels
    const attributes = Object.keys(
      state.generalReport.weekly_sales_interactions_data[0]
    ).filter((key) => key !== "label"); // Excluir 'label'

    // Crear la lista de datos con el formato deseado
    const dataList = attributes.map((attr) => {
      const row = [attr]; // Agregar el nombre del atributo como primer elemento
      row.push(
        ...state.generalReport.weekly_sales_interactions_data.map(
          (item) => item[attr]
        )
      ); // Agregar los valores correspondientes
      return row;
    });

    return { labels, data: dataList };
  } else {
    return { labels: [], data: [] };
  }
};
export const getInteraccionGeneralReport = (state) => {
  if (
    state.generalReport &&
    state.generalReport.weekly_interaction_general_list.length > 1
  ) {
    const labels = state.generalReport.weekly_interaction_general_list.map(
      (item) => item.label
    ); // Lista de labels
    const attributes = Object.keys(
      state.generalReport.weekly_interaction_general_list[0]
    ).filter((key) => key !== "label"); // Excluir 'label'

    // Crear la lista de datos con el formato deseado
    const dataList = attributes.map((attr) => {
      const row = [attr]; // Agregar el nombre del atributo como primer elemento
      row.push(
        ...state.generalReport.weekly_interaction_general_list.map(
          (item) => item[attr]
        )
      ); // Agregar los valores correspondientes
      return row;
    });

    return { labels, data: dataList };
  } else {
    return { labels: [], data: [] };
  }
};
export const getInteraccionesAsesor = (state) => {
  if (
    state.generalReport &&
    state.generalReport.users_interactions_list.length > 1
  ) {
    // Crear la lista de datos con el formato deseado
    const labels = Object.keys(state.generalReport.users_interactions_list[0]);
    const dataList = state.generalReport.users_interactions_list.map((user) => [
      user["usuario"],
      ...labels.slice(1).map((label) => user[label]),
    ]);

    return { labels, data: dataList };
  } else {
    return { labels: [], data: [] };
  }
};
export const getRecompraGeneralReport = (state) => {
  if (state.recompraReport && state.recompraReport.weekly_data.length > 1) {
    const labels = state.recompraReport.weekly_data.map((item) => item.label); // Lista de labels
    const attributes = Object.keys(state.recompraReport.weekly_data[0]).filter(
      (key) => key !== "label"
    ); // Excluir 'label'

    // Crear la lista de datos con el formato deseado
    const dataList = attributes.map((attr) => {
      const row = [attr]; // Agregar el nombre del atributo como primer elemento
      row.push(...state.recompraReport.weekly_data.map((item) => item[attr])); // Agregar los valores correspondientes
      return row;
    });

    return { labels, data: dataList };
  } else {
    return { labels: [], data: [] };
  }
};
export const getRecompraVentasAsesor = (state) => {
  if (state.recompraReport && state.recompraReport.users_counters.length > 1) {
    // Crear la lista de datos con el formato deseado
    const labels = Object.keys(state.recompraReport.users_counters[0]);
    const dataList = state.recompraReport.users_counters.map((user) => [
      user["usuario"],
      ...labels.slice(1).map((label) => user[label]),
    ]);

    return { labels, data: dataList };
  } else {
    return { labels: [], data: [] };
  }
};
export const getRecompraVentasInteracciones = (state) => {
  if (
    state.recompraReport &&
    state.recompraReport.weekly_sales_interactions_data.length > 1
  ) {
    const labels = state.recompraReport.weekly_sales_interactions_data.map(
      (item) => item.label
    ); // Lista de labels
    const attributes = Object.keys(
      state.recompraReport.weekly_sales_interactions_data[0]
    ).filter((key) => key !== "label"); // Excluir 'label'

    // Crear la lista de datos con el formato deseado
    const dataList = attributes.map((attr) => {
      const row = [attr]; // Agregar el nombre del atributo como primer elemento
      row.push(
        ...state.recompraReport.weekly_sales_interactions_data.map(
          (item) => item[attr]
        )
      ); // Agregar los valores correspondientes
      return row;
    });

    return { labels, data: dataList };
  } else {
    return { labels: [], data: [] };
  }
};
export const getRecompraInteraccionGeneralReport = (state) => {
  if (
    state.recompraReport &&
    state.recompraReport.weekly_interaction_general_list.length > 1
  ) {
    const labels = state.recompraReport.weekly_interaction_general_list.map(
      (item) => item.label
    ); // Lista de labels
    const attributes = Object.keys(
      state.recompraReport.weekly_interaction_general_list[0]
    ).filter((key) => key !== "label"); // Excluir 'label'

    // Crear la lista de datos con el formato deseado
    const dataList = attributes.map((attr) => {
      const row = [attr]; // Agregar el nombre del atributo como primer elemento
      row.push(
        ...state.recompraReport.weekly_interaction_general_list.map(
          (item) => item[attr]
        )
      ); // Agregar los valores correspondientes
      return row;
    });

    return { labels, data: dataList };
  } else {
    return { labels: [], data: [] };
  }
};
export const getRecompraInteraccionesAsesor = (state) => {
  if (
    state.recompraReport &&
    state.recompraReport.users_interactions_list.length > 1
  ) {
    // Crear la lista de datos con el formato deseado
    const labels = Object.keys(state.recompraReport.users_interactions_list[0]);
    const dataList = state.recompraReport.users_interactions_list.map(
      (user) => [
        user["usuario"],
        ...labels.slice(1).map((label) => user[label]),
      ]
    );

    return { labels, data: dataList };
  } else {
    return { labels: [], data: [] };
  }
};
export const getFunnel = (state) => {
  if (state.recompraReport && state.recompraReport.tabla) {
    const labels = [
      "Acum. Interacciones",
      "Acum. Personas",
      "Acum. Leads",
      "Acum. Negocios",
      "Acum. Cierre Ganado",
    ];
    const labels2 = [
      "% Interacciones",
      "% Interacciones vs Personas",
      "% Interacciones vs Leads",
      "% Interacciones vs Negocios",
      "% Ventas vs Interacciones",
    ];
    console.log(
      "state.recompraReport.tabla[0].data: ",
      state.recompraReport.tabla[0].data
    );
    const data = state.recompraReport.tabla[0].data.map((item) => ({
      Usuario: item.Usuario,
      data: labels.map((label) => item[label]),
    }));
    const data2 = state.recompraReport.tabla[0].data.map((item) => ({
      Usuario: item.Usuario,
      data: labels2.map((label) => item[label]),
    }));
    return { labels, labels2, data, data2 };
  } else {
    return { labels: [], labels2: [], data: [], data2: [] };
  }
};
